import { useState } from "react";
import { Check, Pencil, Plus, Trash2, X } from "lucide-react";

const pill = "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors";

const NameInput = ({ initial = "", onSave, onCancel, testid }) => {
  const [name, setName] = useState(initial);
  const submit = (e) => {
    e.preventDefault();
    if (name.trim()) onSave(name.trim());
  };
  return (
    <form onSubmit={submit} className="inline-flex items-center gap-1 rounded-full border border-sky-400 bg-white py-1 pl-4 pr-1" data-testid={testid}>
      <input autoFocus maxLength={60} value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Escape" && onCancel()}
        placeholder="Tab name" className="w-36 bg-transparent text-sm text-ink outline-none" data-testid={`${testid}-input`} />
      <button type="submit" aria-label="Save tab name" className="rounded-full p-1.5 text-sky-700 hover:bg-sky-50" data-testid={`${testid}-save`}><Check className="h-4 w-4" /></button>
      <button type="button" onClick={onCancel} aria-label="Cancel" className="rounded-full p-1.5 text-slate-500 hover:bg-slate-100" data-testid={`${testid}-cancel`}><X className="h-4 w-4" /></button>
    </form>
  );
};

export const TabsBar = ({ tabs, active, onSelect, isAdmin, onAdd, onRename, onDelete }) => {
  const [mode, setMode] = useState(null);
  const current = tabs.find((t) => t.id === active);
  const done = (fn) => async (name) => {
    if (await fn(name)) setMode(null);
  };
  return (
    <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="File tabs" data-testid="apps-tabs">
      {tabs.map((t) => (mode === "rename" && t.id === active ? (
        <NameInput key={t.id} initial={t.name} onSave={done((n) => onRename(t.id, n))} onCancel={() => setMode(null)} testid="apps-tab-rename" />
      ) : (
        <button key={t.id} role="tab" aria-selected={t.id === active} onClick={() => onSelect(t.id)}
          className={`${pill} ${t.id === active ? "border-ink bg-ink text-white" : "border-slate-200 bg-white text-ink hover:border-sky-600 hover:text-sky-700"}`} data-testid={`apps-tab-${t.id}`}>
          {t.name}
          {isAdmin && <span className={`rounded-full px-1.5 font-mono text-[11px] ${t.id === active ? "bg-white/15" : "bg-sky-50 text-sky-800"}`}>{t.file_count}</span>}
        </button>
      )))}
      {isAdmin && (mode === "add" ? (
        <NameInput onSave={done(onAdd)} onCancel={() => setMode(null)} testid="apps-tab-add" />
      ) : (
        <button onClick={() => setMode("add")} className={`${pill} border-dashed border-sky-300 bg-transparent text-sky-700 hover:border-sky-600`} data-testid="apps-tab-add-button"><Plus className="h-4 w-4" />Add tab</button>
      ))}
      {isAdmin && current && !mode && (
        <span className="inline-flex items-center">
          <button onClick={() => setMode("rename")} title={`Rename "${current.name}"`} className="rounded-full p-2 text-slate-500 hover:bg-sky-50 hover:text-sky-700" data-testid="apps-tab-rename-button"><Pencil className="h-4 w-4" /></button>
          <button onClick={() => onDelete(current)} title={current.file_count ? `Move or delete its ${current.file_count} file(s) before removing "${current.name}"` : `Remove "${current.name}"`}
            className="rounded-full p-2 text-slate-500 hover:bg-red-50 hover:text-red-700" data-testid="apps-tab-delete-button"><Trash2 className="h-4 w-4" /></button>
        </span>
      )}
    </div>
  );
};
